import { render, staticRenderFns } from "./EtugStandards.vue?vue&type=template&id=4841215e&"
import script from "./EtugStandards.vue?vue&type=script&lang=js&"
export * from "./EtugStandards.vue?vue&type=script&lang=js&"
import style0 from "./EtugStandards.vue?vue&type=style&index=0&id=4841215e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports